import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import BgSpImg from 'ui/images/top/bg_ribbon_sp.svg';
import BgPcImg from 'ui/images/top/bg_ribbon_pc.svg';
import BgNum1Img from 'ui/images/top/about_many_num_1.svg';
import BgNum2Img from 'ui/images/top/about_many_num_2.svg';
import BgNum3Img from 'ui/images/top/about_many_num_3.svg';
import AboutManyPcImg from 'ui/images/top/about_many_pc.svg';
import AboutManySpImg from 'ui/images/top/about_many_sp.svg';
import AboutManyTopImg from 'ui/images/top/about_many_top.svg';
import AboutMany1Img from 'ui/images/top/about_many_4.png';
import AboutMany2Img from 'ui/images/top/about_many_5.png';
import AboutMany3Img from 'ui/images/top/about_many_6.png';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--white);
    gap: 5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 2rem;

    ${mqMin('NARROW')} {
        gap: 8rem;
    }
`;

const SectionTop = styled.div`
    line-height: 1.8em;
    background-image: url(${BgSpImg});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: left 0px top 6rem;
    padding: 5rem 0;
    margin-bottom: -8rem;

    ${mqMin('NARROW')} {
        padding: 8rem 0;
        background-position: left 0px top 13rem;
        background-image: url(${BgPcImg});
    }
`;

const Section = styled.div`
    line-height: 1.8em;
    width: 100%;
    margin: 0 auto;
`;

const AboutManyPcTitle = styled.img`
    display: none;
    width: 20rem;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        display: block;
    }
`;

const AboutManySpTitle = styled.img`
    display: block;
    width: 15rem;
    margin: 0 auto 4rem auto;

    ${mqMin('NARROW')} {
        display: none;
    }
`;

const DarkBlueText = styled.div`
    color: var(--dark-blue);
    font-size: 1.5rem;
    line-height: 3rem;
    gap: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
    padding: 0 0.7rem;

    ${mqMin('NARROW')} {
        line-height: 3.3rem;
        flex-direction: row;
        font-size: 1.7rem;
    }
`;

const DarkBlueSmallText = styled.div`
    color: var(--dark-blue);
    font-size: 1.1rem;
    line-height: 2rem;
    width: 100%;
    margin-top: 1rem;
    text-align: left;

    span {
        text-decoration: underline;
        text-decoration-color: var(--dark-blue);
    }
`;

const DarkBlueVerySmallText = styled.div`
    color: var(--dark-blue);
    font-size: 0.8rem;
    line-height: 1.8rem;
    margin-top: 0.5rem;
    width: 100%;
    text-align: left;

    span {
        text-decoration: underline;
        text-decoration-color: var(--dark-blue);
    }
`;

const Strong = styled.strong`
    position: relative;
    font-size: 2.1rem;
    color: var(--blue);

    ${mqMin('NARROW')} {
        font-size: 2.3rem;
    }
`;

const StrongWithAfter = styled(Strong)`
    &::after {
        position: absolute;
        left: 50%;
        content: '・';
        transform: translateX(-50%);
        top: -1.8rem;
        font-size: 1.8rem;

        ${mqMin('NARROW')} {
            top: -2rem;
            font-size: 2rem;
        }
    }
`;

const AboutManyTopImgItem = styled.img`
    width: 18.8rem;
    height: auto;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        width: 25rem;
    }
`;

const AboutMany1ImgItem = styled.img`
    width: 23.75rem;
    height: auto;
    margin: 4.5rem auto 0 auto;
    border-radius: 10px;

    ${mqMin('NARROW')} {
        width: 40rem;
        margin: 0 auto;
    }
`;

const AboutMany2ImgItem = styled.img`
    width: 23.7rem;
    height: auto;
    margin: 4.5rem auto 0 auto;
    border-radius: 10px;

    ${mqMin('NARROW')} {
        width: 40rem;
        margin: 0 auto;
    }
`;

const AboutMany3ImgItem = styled.img`
    width: 23.7rem;
    height: auto;
    margin: 4.5rem auto 0 auto;
    border-radius: 10px;

    ${mqMin('NARROW')} {
        width: 40rem;
        margin: 0 auto;
    }
`;

const About1Container = styled.div`
    background-image: url(${BgNum1Img});
    background-repeat: no-repeat;
    background-size: 10.8rem;
    background-position: left 0 top 0;
    height: 100%;
    margin-bottom: auto;
    padding-top: 2.5rem;

    ${mqMin('NARROW')} {
        background-position: left 2rem top 0;
    }
`;

const About2Container = styled.div`
    background-image: url(${BgNum2Img});
    background-repeat: no-repeat;
    background-size: 10.8rem;
    background-position: left 0 top 0;
    height: 100%;
    margin-bottom: auto;
    padding-top: 2.5rem;

    ${mqMin('NARROW')} {
        background-position: left 2rem top 0;
    }
`;

const About3Container = styled.div`
    background-image: url(${BgNum3Img});
    background-repeat: no-repeat;
    background-size: 10.8rem;
    background-position: left 0 top 0;
    height: 100%;
    margin-bottom: auto;
    padding-top: 2.5rem;

    ${mqMin('NARROW')} {
        background-position: left 2rem top 0;
    }
`;

const VideoContainer = styled.div`
    position: relative;
    width: 20rem;
    margin: 2rem auto;
    height: 12rem;
    background-color: #000;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
        transform: scale(1.02);
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 12px;
        pointer-events: none;
    }

    ${mqMin('SP')} {
        width: 50rem;
        margin: 3rem auto 0;
        height: 30rem;
    }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
`;

const ModalVideoContainer = styled.div`
    position: relative;
    width: 90vw;
    height: 60vh;
    background-color: #000;
    border-radius: 12px;
    overflow: hidden;
    z-index: 1001;

    ${mqMin('NARROW')} {
        width: 80vw;
        height: 70vh;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: -50px;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    border: none;
    color: #fff;
    font-size: 2rem;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 50%;
    z-index: 1002;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(0, 0, 0, 0.9);
    }
`;

export const SubTitleSection: React.FC = () => {
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);

    const handleVideoClick = (videoId: string) => {
        setSelectedVideo(videoId);
    };

    const handleCloseModal = () => {
        setSelectedVideo(null);
    };

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && selectedVideo) {
                handleCloseModal();
            }
        };

        if (selectedVideo) {
            document.addEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [selectedVideo]);
    return (
        <Container id="about-many">
            <SectionTop className="fadein fadein_y">
                <AboutManyPcTitle src={AboutManyPcImg} alt="MAnyとは" />
                <AboutManySpTitle src={AboutManySpImg} alt="MAnyとは" />

                <DarkBlueText>
                    <div>
                        <StrongWithAfter>完</StrongWithAfter>
                        <StrongWithAfter>全</StrongWithAfter>
                        <StrongWithAfter>無</StrongWithAfter>
                        <StrongWithAfter>料</StrongWithAfter>
                        で、
                        <Only sp>
                            <br />
                        </Only>
                        事業承継に最適な仲介会社を
                        <br />
                        選択するための
                        <Only sp>
                            <br />
                        </Only>
                        <Strong>比較面談</Strong>ができます。 <br />
                        <Only sp>
                            <AboutManyTopImgItem src={AboutManyTopImg} alt="イラスト" />
                        </Only>
                        <DarkBlueSmallText>
                            専任契約をする前に、あなたの会社の<span>評価方法</span>や
                            <Only pc>
                                <br />
                            </Only>
                            <span>買い手の条件</span>、 <span>手数料</span>などを相談して比較できます。
                        </DarkBlueSmallText>
                    </div>
                    <Only pc>
                        <AboutManyTopImgItem src={AboutManyTopImg} alt="イラスト" />
                    </Only>
                </DarkBlueText>
                <VideoContainer onClick={() => handleVideoClick('hwFMIBPNQUs')}>
                    <iframe
                        src={`https://www.youtube.com/embed/hwFMIBPNQUs`}
                        title="YouTube動画"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </VideoContainer>
            </SectionTop>
            <Section className="fadein fadein_y">
                <Only pc>
                    <DarkBlueText>
                        <div>
                            <AboutMany1ImgItem src={AboutMany1Img} alt="イラスト" />
                        </div>
                        <About1Container>
                            <Strong>最大5社</Strong>と面談可能
                            <DarkBlueSmallText>
                                <br />
                                様々な特色の仲介会社から
                                <br />
                                オファーを受けて<span>最大5社と面談可能</span>
                                <br />
                                <br />
                                ※面談数は申請により<span>無料で増やせます</span>。
                            </DarkBlueSmallText>
                        </About1Container>
                    </DarkBlueText>
                </Only>
                <Only sp>
                    <DarkBlueText>
                        <About1Container>
                            <Strong>最大5社</Strong>と面談可能
                            <div>
                                <AboutMany1ImgItem src={AboutMany1Img} alt="イラスト" />
                            </div>
                            <DarkBlueSmallText>
                                様々な特色の仲介会社からオファーを受けて<span>最大5社と面談可能</span>
                            </DarkBlueSmallText>
                            <DarkBlueVerySmallText>
                                ※面談数は申請により<span>無料で増やせます</span>。
                            </DarkBlueVerySmallText>
                        </About1Container>
                    </DarkBlueText>
                </Only>
            </Section>
            <Section className="fadein fadein_y">
                <Only pc>
                    <DarkBlueText>
                        <About2Container>
                            <Strong>初めて</Strong>の方でも安心の機能
                            <DarkBlueSmallText>
                                <br />
                                「始めてで何を聞けばいいの？」という方に、 <br />
                                <span>選ぶだけでトラブル防止に役立つ質問</span>が可能
                            </DarkBlueSmallText>
                        </About2Container>
                        <div>
                            <AboutMany2ImgItem src={AboutMany2Img} alt="イラスト" />
                        </div>
                    </DarkBlueText>
                </Only>
                <Only sp>
                    <DarkBlueText>
                        <About2Container>
                            <Strong>初めて</Strong>の方でも安心の機能
                            <div>
                                <AboutMany2ImgItem src={AboutMany2Img} alt="イラスト" />
                            </div>
                            <DarkBlueSmallText>
                                「始めてで何を聞けばいいの？」という方に、
                                <span>選ぶだけでトラブル防止に役立つ質問</span>が可能
                            </DarkBlueSmallText>
                        </About2Container>
                    </DarkBlueText>
                </Only>
            </Section>
            <Section className="fadein fadein_y">
                <Only pc>
                    <DarkBlueText>
                        <div>
                            <AboutMany3ImgItem src={AboutMany3Img} alt="イラスト" />
                        </div>
                        <About3Container>
                            <Strong>完全無料</Strong>で利用可能
                            <DarkBlueSmallText>
                                <br />
                                売り手企業様は<span>すべての機能を無料</span>でお使いいただけます。
                                <br />
                                あなたの要望に合わせた仲介会社とマッチ可能です。
                            </DarkBlueSmallText>
                        </About3Container>
                    </DarkBlueText>
                </Only>
                <Only sp>
                    <DarkBlueText>
                        <About3Container>
                            <Strong>完全無料</Strong>で利用可能
                            <div>
                                <AboutMany3ImgItem src={AboutMany3Img} alt="イラスト" />
                            </div>
                            <DarkBlueSmallText>
                                売り手企業様は<span>すべての機能を無料</span>でお使いいただけます。
                                <br />
                                あなたの要望に合わせた仲介会社とマッチ可能です。
                            </DarkBlueSmallText>
                        </About3Container>
                    </DarkBlueText>
                </Only>
            </Section>
            {selectedVideo && (
                <ModalOverlay onClick={handleCloseModal}>
                    <ModalVideoContainer onClick={(e) => e.stopPropagation()}>
                        <CloseButton onClick={handleCloseModal}>×</CloseButton>
                        <iframe
                            src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1`}
                            title="YouTube動画"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </ModalVideoContainer>
                </ModalOverlay>
            )}
        </Container>
    );
};
